import { render, staticRenderFns } from "./FourPlayer.vue?vue&type=template&id=11f896c1&"
import script from "./FourPlayer.vue?vue&type=script&lang=ts&"
export * from "./FourPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports